import { useScreenDispatch } from '@gogame/screens';

import { SET_DIMENSION } from 'scenes/Trackers/HourlyTracker/reducers';
import { useEnsureTemporaryStateProp } from 'scenes/Trackers/HourlyTracker/useEnsureTemporaryStateProp';

import { PathBuilder } from './PathBuilder';

export const HourlyTrackerPathBuilder = ({
  dimensions,
  drillTo,
  nextLevel,
  onChangeNextLevel,
}) => {
  const drillPath = useEnsureTemporaryStateProp('drillPath'); // todo: move to props
  const dispatch = useScreenDispatch(); // todo: move to props
  const dimension = [...drillPath].pop()?.type;

  const handleChangeDimension = async (_e, value) => {
    dispatch({
      type: SET_DIMENSION,
      payload: value,
    });
  };

  return (
    <PathBuilder
      dimensions={dimensions}
      drillTo={drillTo}
      nextLevel={nextLevel}
      onChangeNextLevel={onChangeNextLevel}
      onChangeDimension={handleChangeDimension}
      dimensionValue={dimension}
    />
  );
};
